import { ITreeviewLopFocusedValue } from "../../../components-data/treeview-lop/TreeviewLop";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IStrIdsRequest } from "../../../model/request/IStrIdsRequest";
import { IDotXetHocVuPhamViSinhVienViewModel } from "../../../model/response/xet-hoc-vu/IDotXetHocVuPhamViSinhVienViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDotXetHocVuPhamViSinhVienActionsObj = {
    LOAD_BY_HOC_KY_NAM_HOC_START: {} as { hoc_ky: number, nam_hoc: string },
    LOAD_BY_HOC_KY_NAM_HOC_SUCCESS: {} as IDotXetHocVuPhamViSinhVienViewModel[],
    LOAD_BY_HOC_KY_NAM_HOC_ERROR: "",

    INSERTS_START: {} as  { id_dot_xet: number, request: IStrIdsRequest },
    INSERTS_SUCCESS: undefined,
    INSERTS_ERROR: "",

    DELETES_START: {} as  { request: IIdsRequest },
    DELETES_SUCCESS: undefined,
    DELETES_ERROR: "",

    TREEVIEW_LOP_FOCUSED_VALUE_CHANGE: {} as ITreeviewLopFocusedValue,

    CHANGE_IS_HIEN_THI_THEO_PHAM_VI_LOP: {} as boolean,

    CHANGE_IS_HIEN_THI_THEO_TRANG_THAI: {} as boolean,
}

export const eDotXetHocVuPhamViSinhVienActionIds = generateActionTypeIds(eDotXetHocVuPhamViSinhVienActionsObj, "DOT_XET_HOC_VU_PHAM_VI_SINH_VIEN");
export type IDotXetHocVuPhamViSinhVienActionTypes = IGenericActionType<typeof eDotXetHocVuPhamViSinhVienActionsObj, "DOT_XET_HOC_VU_PHAM_VI_SINH_VIEN">;